

export const formatAmount = (amount) => {
    if (isNaN(amount)) return amount; // Return the original value if it's not a number

    const formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return `${formatter.format(amount)}`;
};

export const formatGermanAmount = (value) => {
    if (value === "") return "";

    // Remove non-numeric characters except for commas and dots
    let cleanedValue = value.replace(/[^0-9,\.]/g, '').trim();

    // Check if there's a comma in the string (indicating the decimal part)
    if (cleanedValue.includes(',')) {
        // Handle multiple decimal points and commas properly
        // Split into integer and decimal parts
        let [integerPart, decimalPart] = cleanedValue.split(',');

        // Remove any dots from the integer part
        integerPart = integerPart.replace(/\./g, '');

        // Limit the decimal part to at most 2 digits
        decimalPart = decimalPart.substring(0, 2);

        // Recombine the integer and decimal parts
        cleanedValue = `${integerPart},${decimalPart}`;
    } else {
        // If no comma, just remove all dots (thousands separators)
        cleanedValue = cleanedValue.replace(/\./g, '');
    }

    // Parse the cleaned value into a number
    const numericValue = parseFloat(cleanedValue.replace(',', '.'));

    if (isNaN(numericValue)) return "";

    // Use Intl.NumberFormat to format the number in German style
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numericValue);
};


export const formatPlainAmount = (value) => {
    if (!value) return "";

    if (typeof value === 'number') return value;

    // Convert German format to plain format
    const plainValue = value?.replace(/\./g, '')?.replace(',', '.');

    // Ensure two decimal places
    return parseFloat(plainValue).toFixed(2);
};

export const formatUpdateNumber = (value) => {
    if (typeof value === "number") {
        return new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }

    // If it's a string, convert to float first
    const number = parseFloat(value.replace(',', '.'));
    if (isNaN(number)) return value; // Return original if not a valid number

    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);
}

export const handleKeyPress = (e) => {
    // Only allow digits, comma and period
    const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];

    if (!validKeys.includes(e.key)) {
        e.preventDefault(); // Prevent entering invalid characters
    }
};

export const formatGermanPercentage = (value) => {
    if (typeof value !== 'number' || isNaN(value)) return '0,00';

    const decimalPart = value - Math.floor(value);

    // if (decimalPart >= 0.5) {
    //     // Round to whole number
    //     const rounded = Math.round(value + Number.EPSILON);
    //     return new Intl.NumberFormat('de-DE').format(rounded);
    // } else {
        // Keep 2 decimals
        // const rounded = Math.floor(value * 100) / 100;
        return new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    // }
};
